import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bdefc3c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdefc3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/live-front-end_XotX/plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bdefc3c')) {
      api.createRecord('2bdefc3c', component.options)
    } else {
      api.reload('2bdefc3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bdefc3c&scoped=true", function () {
      api.rerender('2bdefc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nosocomiumList/nosocomiumListFrom/index.vue"
export default component.exports